<template>
  <div class="outer-wrap">
    <div class="inner-page-wrap">
      <div style="width: 100%">
        <div class="filter flex">
          <el-input
            v-model="search"
            style="width: 300px"
            placeholder="输入账号/用户名搜索"
          />
          <el-button style="margin-left: 16px" @click="resetFilter"
            >重置</el-button
          >
          <el-button type="primary" @click="handleSearch">查询</el-button>
        </div>
        <el-table
          :data="list"
          v-loading="loading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.1)"
          :height="tableHeight"
          ref="table"
        >
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-form label-position="left" class="demo-table-expand">
                <el-form-item label="部门">
                  <span>{{ props.row.orgName }}</span>
                </el-form-item>
                <el-form-item label="用户权限">
                  <span>{{ props.row.permStr }}</span>
                </el-form-item>
                <el-form-item label="权限明细">
                  <span>{{ props.row.permCode }}</span>
                </el-form-item>
                <el-form-item label="备注">
                  <span>{{ props.row.remark }}</span>
                </el-form-item>
              </el-form>
            </template>
          </el-table-column>
          <el-table-column label="id" prop="id" width="200"></el-table-column>
          <el-table-column
            label="账号"
            prop="username"
            width="200"
          ></el-table-column>
          <el-table-column
            label="用户名"
            prop="name"
            width="200"
          ></el-table-column>
          <el-table-column label="角色" prop="roleNames">
            <template slot-scope="scope">
              <div v-if="scope.row.roleNames">
                <el-tag
                  @click="jumpRoleManage(item)"
                  size="mini"
                  type="info"
                  style="margin-right: 5px; cursor: pointer"
                  v-for="item in scope.row.roleNames.split(',')"
                  :key="item"
                  >{{ item }}
                </el-tag>
              </div>
              <div v-else>--</div>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="480">
            <!-- <template slot="header" slot-scope="scope">
            
          </template> -->
            <template slot-scope="scope">
              <!-- <el-button class="edit-btn" size="mini" @click="handleEdit(scope.row)">编辑</el-button> -->
              <el-button
                class="edit-btn"
                type="text"
                @click="assignAdAccount(scope.row)"
                >分配广告账号</el-button
              >
              <el-button
                class="edit-btn"
                type="text"
                @click="handleChannelPerm(scope.row)"
                >基础权限配置</el-button
              >
              <el-button
                class="edit-btn"
                type="text"
                @click="handleRole(scope.row)"
                >权限管理</el-button
              >
              <el-button
                class="edit-btn"
                type="text"
                @click="handleSearchPerm(scope.row)"
                >产品权限查询</el-button
              >
              <el-button
                type="text"
                v-permission="['permisssion:write:role:addUserRolesButton']"
                @click="handleRoleManage(scope.row)"
                >角色管理</el-button
              >
              <!-- <el-button
              class="delete-btn"
              size="mini"
              type="danger"
              @click="handleDelete(scope.row)"
            >删除</el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </div>

      <perms-transfer-dialog
        :permsRoleList="permsRoleList"
        :selePermValue="selePermValue"
        :search="search"
        ref="persTransferRef"
        :uid="uid"
        flag="user"
        @closeDialog="closeDialog"
      ></perms-transfer-dialog>
      <!-- <dialog-tip
        @deleteTableItem="deleteTableItem"
        :visibleShow="visibleShow"
        :productName="productName"
        @closeDialogTip="closeDialogTip"
      ></dialog-tip> -->
      <!-- 分配广告账号 -->
      <assign-ad-modal ref="assignModal"></assign-ad-modal>
      <!-- 查看关联账号 -->
      <check-account-modal ref="checkModal"></check-account-modal>
      <channel-perm-modal
        :refType="2"
        ref="channelPermModal"
      ></channel-perm-modal>
      <product-perm-search-modal
        ref="productPermSearchModal"
      ></product-perm-search-modal>
      <role-manage-modal
        ref="roleManageModalRef"
        @refresh="getList"
      ></role-manage-modal>
    </div>
    <div class="outer-pagination-wrap">
      <self-pagination
        :total="pageData.total"
        :pageSize="pageData.size"
        :currentPage="pageData.page"
        @getCurrentPage="changePage"
        @handleSizeChange="handleSizeChange"
        :hideSiglePage="false"
      ></self-pagination>
    </div>
  </div>
</template>
<script>
import { getUserList } from "@/api/account-management.js";

export default {
  data() {
    return {
      search: "",
      selectUserValue: [],
      selePermValue: [],
      uid: "",
      visibleShow: false,
      productName: "",
      list: [],
      pageData: {
        total: 0,
        size: 10,
        page: 1,
      },
      loading: false,
      tableHeight: window.innerHeight - 250,
    };
  },
  props: {},
  components: {
    RoleManageModal: () => import("./roleManageModal"),
    PermsTransferDialog: () => import("./permsTransferDialog"),
    // DialogTip: () => import("@/pages/account/product/dialogTip"),
    AssignAdModal: () => import("./assignAdModal.vue"),
    ProductPermSearchModal: () => import("./productPermSearchModal.vue"),
    CheckAccountModal: () =>
      import("@/pages/account/user-manage/checkAccountModal"),
    ChannelPermModal: () =>
      import("@/pages/account/role-manage/channelPermModal"),
  },
  computed: {
    permsRoleList: function () {
      return this.$store.state.RolePower.permsRoleList;
    },
  },
  methods: {
    getList() {
      this.loading = true;
      getUserList({
        pageNum: this.pageData.page,
        pageSize: this.pageData.size,
        condition: this.search,
      }).then((res) => {
        if (res.code == "0000") {
          this.pageData.total = res.data.userCount;
          this.list = res.data.pageUserInfo;
        }
        this.loading = false;
      });
    },
    resetFilter() {
      this.search = "";
      this.pageData.page = 1;
      this.getList();
    },
    handleSearch() {
      this.pageData.page = 1;
      this.getList();
    },
    assignAdAccount(data) {
      this.$refs.assignModal.showModal(data.id);
    },
    checkConAccount(lineData) {
      let title = lineData.name + "关联的广告账号";
      this.$refs.checkModal.showModal(lineData, title, "user");
    },
    handleSearchPerm(data) {
      this.$refs.productPermSearchModal.showModal(data);
    },
    handleChannelPerm(data) {
      this.$refs.channelPermModal.showModal(data);
    },
    jumpRoleManage(item) {
      window.open(`/#/roles-new.html?roleName=${item}`, "_blank");
    },
    handleRole(row) {
      this.selePermValue = row.permId == "" ? [] : row.permId.split(",");
      this.$refs.persTransferRef.showModal();
      this.uid = row.id.toString();
    },
    // handleDelete(row) {
    //   this.visibleShow = true;
    //   this.productName = row.username;
    //   this.uid = row.id.toString();
    // },
    handleEdit(row) {
      this.$emit("editUserManage", row);
    },
    closeDialog() {
      // this.permdialogVisible = false;
    },
    closeDialogTip() {
      // this.visibleShow = false;
    },
    // deleteTableItem() {
    //   this.$store.dispatch("delUser", {
    //     param: { userId: this.uid },
    //     cb: (data) => {
    //       if (data.code == "0000") {
    //         this.visibleShow = false;
    //         this.$store.dispatch("getRoleUserList", {
    //           param: {
    //             currentPage: this.$store.state.RolePower.userCurrentPage,
    //             pageSize: 10,
    //           },
    //           cb: () => {
    //             this.$emit("showLoading", false);
    //           },
    //         });
    //       }
    //     },
    //   });
    // },
    handleRoleManage(data) {
      this.$refs.roleManageModalRef.showModal(data);
    },
    changePage(page) {
      this.pageData.page = page;
      this.getList();
    },
    handleSizeChange(size) {
      this.pageData.size = size;
      this.pageData.page = 1;
      this.getList();
    },
    refresh() {
      this.tableHeight = window.innerHeight - 250;
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
    },
  },

  mounted() {
    this.getList();
    let _this = this;
    window.onresize = () => {
      return _this.refresh();
    };
  },
};
</script>

<style lang="less" scoped>
.outer-wrap {
  .filter {
    flex: 1;
    margin-bottom: 16px;
    .multiple-select {
      margin-left: 16px;
      width: 220px;
      /deep/ .el-tag.el-tag--info:first-child {
        max-width: 120px;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}
</style>
